import Reveal from "../common/reveal";
import { BOOKS } from "../../data/books";

const [PRIMARY, SECOND] = BOOKS;

const BooksSection = () => (
	<Reveal as="section" className="wrap sec">
		<div
			className="secnum"
			style={{ marginBottom: "clamp(28px, 4vw, 48px)" }}
		>
			03 · Books
		</div>

		<div
			className="split-wide rule-bottom-soft"
			style={{ paddingBottom: "clamp(40px, 6vw, 72px)" }}
		>
			<div style={{ flex: "0 1 300px", minWidth: "200px" }}>
				<img
					src={process.env.PUBLIC_URL + PRIMARY.cover}
					alt={PRIMARY.coverAlt}
					className="book-cover-lg"
				/>
			</div>
			<div style={{ flex: "1 1 420px", minWidth: 0 }}>
				<div
					className="secmeta"
					style={{ letterSpacing: "0.12em" }}
				>
					{PRIMARY.credit}
				</div>
				<h2
					style={{
						fontFamily: "Newsreader, serif",
						fontWeight: 300,
						fontSize: "clamp(30px, 4vw, 48px)",
						lineHeight: 1.1,
						letterSpacing: "-0.022em",
						margin: "16px 0 0",
						color: "var(--fg)",
					}}
				>
					{PRIMARY.title}
				</h2>
				<div
					style={{
						fontFamily: "Newsreader, serif",
						fontStyle: "italic",
						fontWeight: 300,
						fontSize: "clamp(18px, 1.8vw, 22px)",
						lineHeight: 1.35,
						color: "var(--sec)",
						marginTop: "10px",
						maxWidth: "34ch",
					}}
				>
					{PRIMARY.subtitle}
				</div>
				<p
					className="p-body p-narrow"
					style={{ marginTop: "26px" }}
				>
					{PRIMARY.description}
				</p>
				<div
					style={{
						display: "flex",
						flexWrap: "wrap",
						gap: "12px 32px",
						marginTop: "28px",
						alignItems: "center",
					}}
				>
					<span className="chip-accent">{PRIMARY.accolade}</span>
					{PRIMARY.links.map((link) => (
						<a
							key={link.label}
							href={link.link}
							target="_blank"
							rel="noreferrer"
							className="link-out"
						>
							{link.label}
						</a>
					))}
				</div>
				<div
					className="secmeta"
					style={{
						letterSpacing: "normal",
						textTransform: "none",
						marginTop: "22px",
					}}
				>
					{PRIMARY.note}
				</div>
			</div>
		</div>

		<div
			className="split-wide"
			style={{ paddingTop: "clamp(40px, 6vw, 64px)" }}
		>
			<div style={{ flex: "0 1 300px", minWidth: "200px" }}>
				{SECOND.cover ? (
					<img
						src={process.env.PUBLIC_URL + SECOND.cover}
						alt={SECOND.coverAlt}
						className="book-cover-lg"
					/>
				) : (
					// Typographic stand-in until cover artwork is supplied.
					<div className="cover-placeholder">
						<div
							className="secmeta"
							style={{
								fontSize: "9.5px",
								letterSpacing: "0.14em",
							}}
						>
							Cover asset
							<br />
							not supplied
						</div>
						<div
							style={{
								fontFamily: "Newsreader, serif",
								fontWeight: 300,
								fontSize: "26px",
								lineHeight: 1.16,
								letterSpacing: "-0.02em",
								color: "var(--fg)",
							}}
						>
							{SECOND.title}
						</div>
					</div>
				)}
			</div>
			<div style={{ flex: "1 1 420px", minWidth: 0 }}>
				<div className="secmeta" style={{ letterSpacing: "0.12em" }}>
					{SECOND.credit}
				</div>
				<h2
					style={{
						fontFamily: "Newsreader, serif",
						fontWeight: 300,
						fontSize: "clamp(26px, 3vw, 36px)",
						lineHeight: 1.14,
						letterSpacing: "-0.02em",
						margin: "14px 0 0",
						color: "var(--fg)",
					}}
				>
					{SECOND.title}
				</h2>
				{SECOND.subtitle && (
					<div
						style={{
							fontFamily: "Newsreader, serif",
							fontStyle: "italic",
							fontWeight: 300,
							fontSize: "clamp(17px, 1.6vw, 20px)",
							lineHeight: 1.35,
							color: "var(--sec)",
							marginTop: "10px",
							maxWidth: "38ch",
						}}
					>
						{SECOND.subtitle}
					</div>
				)}
				<p className="p-body p-narrow" style={{ marginTop: "20px" }}>
					{SECOND.description}
				</p>
				<div style={{ marginTop: "26px" }}>
					{SECOND.links.map((link) => (
						<a
							key={link.label}
							href={link.link}
							target="_blank"
							rel="noreferrer"
							className="link-out"
						>
							{link.label}
						</a>
					))}
				</div>
			</div>
		</div>
	</Reveal>
);

export default BooksSection;
